// Small self-contained inline SVG icons for the AI-trial upgrade page. Using `currentColor`
// everywhere lets the SCSS drive every colour (and dark mode) without extra assets.
import React from 'react';

const base = (size = 20) => ({
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
});

export const SparkleIcon = ({ size }) => (
    <svg {...base(size)}>
        <path
            d="M12 3l1.9 4.6L18.5 9.5 13.9 11.4 12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z"
            fill="currentColor"
        />
        <path d="M18.5 14l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9.9-2.1z" fill="currentColor" />
    </svg>
);

export const InfoIcon = ({ size }) => (
    <svg {...base(size)}>
        <circle cx="12" cy="12" r="9" fill="currentColor" />
        <rect x="11" y="10.5" width="2" height="6.5" rx="1" fill="#fff" />
        <circle cx="12" cy="7.8" r="1.2" fill="#fff" />
    </svg>
);

export const FileIcon = ({ size }) => (
    <svg {...base(size)}>
        <path
            d="M6 3.5h6L18 9v10.5a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 016 19.5v-16z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
        />
        <path d="M12 3.5V9h6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M9 13h6M9 16h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const CalendarIcon = ({ size }) => (
    <svg {...base(size)}>
        <rect x="3.5" y="5" width="17" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const LockIcon = ({ size }) => (
    <svg {...base(size)}>
        <rect x="4.5" y="10.5" width="15" height="9.5" rx="2.2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M7.5 10.5V8a4.5 4.5 0 019 0v2.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="12" cy="15" r="1.4" fill="currentColor" />
    </svg>
);

export const BulbIcon = ({ size }) => (
    <svg {...base(size)}>
        <path
            d="M9 17.5h6M9.5 20h5M12 3.5a6 6 0 00-3.6 10.8c.5.4.8 1 .8 1.7h5.6c0-.7.3-1.3.8-1.7A6 6 0 0012 3.5z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CardIcon = ({ size }) => (
    <svg {...base(size)}>
        <rect x="3" y="6" width="18" height="12" rx="2.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M3 10h18" stroke="currentColor" strokeWidth="1.6" />
        <path d="M6.5 14.5h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const ClockIcon = ({ size }) => (
    <svg {...base(size)}>
        <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const RenewIcon = ({ size }) => (
    <svg {...base(size)}>
        <path
            d="M19 8a7.5 7.5 0 10.6 6"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
        />
        <path d="M19.5 4v4.2h-4.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const ArrowRightIcon = ({ size }) => (
    <svg {...base(size)}>
        <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const LockClosedIcon = LockIcon;
